<template>
  <v-app :dark="nightMode">
    <site-toolbar id="top">
      <api-activity-indicator slot="addon" :color="nightMode ? 'white' : 'black'">
      </api-activity-indicator>
    </site-toolbar>
    <v-content>
      <v-container
        fluid grid-list-md id="app-container"
        v-scroll="onScroll"
      >
        <FlashArticle
        :article="flashArticle"
        @closeArticle="closeFlash(flashArticle)">
        </FlashArticle>
        <router-view></router-view>
        <v-layout row wrap v-show="!isInfinite">
          <v-flex xs12>
            <fresh-news :newsarticles="newsarticles" @addMoreNews="addMoreNews()"></fresh-news>
            <site-footer></site-footer>
          </v-flex>
        </v-layout>
        <mobile-bottom-nav></mobile-bottom-nav>
      </v-container>
    </v-content>
    <snackbars></snackbars>
    <div class="hidden-xs-only" id="vk_community_messages"></div>
    <v-fab-transition>
      <v-btn
        @click="$vuetify.goTo('#top')"
        v-show="isScrolled"
        color="amber darken-1"
        dark fab fixed top right small
        style="margin-top: 50px; margin-right: 0px"
      >
        <v-icon>expand_less</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- <Chat></Chat> -->
    <cookie-law theme="blood-orange">
      <div slot-scope="props">
        Этот сайт использует файлы Cookie для хранения данных.
        Продолжая использовать сайт, Вы даете свое согласие на работу с этими файлами
        <v-spacer></v-spacer>
        С политикой в отношении файлов Cookie можно ознакомиться по
        <a href="https://cdsvyatka.com/storage/documents/1631103377_%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5%20%D0%BD%D0%B0%20%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83%20%D0%9F%D0%94.pdf" target="_blank">ссылке</a>
        <!-- <a href="https://ekarta43.ru/external-content/doc/3_1_3_Cookies_processing_policy.docx" target="_blank">ссылке</a> -->
        <v-spacer></v-spacer>
        <v-btn
          outlined
          color="primary"
          small
          @click="props.accept">
            <b>Принять</b>
        </v-btn>
      </div>
    </cookie-law>
    <!-- <v-dialog
      v-model="chats"
      scrollable
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Согласие на обработку персональных данных
        </v-card-title>
        <v-card-text>
          <span>Для использования чата необходимо ознакомиться с политикой обработки персональных данных и дать согласие на их обработку</span>
          <v-checkbox label="Принимаю политику обработки ПД при обращении в чат" v-model="acceptPD"></v-checkbox>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="chats = !chats">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="savePD()">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <Confirmation></Confirmation>
  </v-app>
</template>

<script>
import moment from 'moment'
import SiteToolbar from '@/components/SiteToolbar'
// import Chat from '@/components/Chat'
import Snackbars from '@/components/Snackbars'
import FreshNews from '@/components/FreshNews'
import SiteFooter from '@/components/SiteFooter'
import MobileBottomNav from '@/components/MobileBottomNav'
import ApiActivityIndicator from '@/components/ApiActivityIndicator'
import FlashArticle from '@/components/FlashArticle'
import Confirmation from '@/components/Confirmation'
import CookieLaw from 'vue-cookie-law'

function readLastArticle () {
  try {
    return JSON.parse(localStorage.getItem('detiLastReadedArticle') || '-1')
  } catch (err) {
    return -1
  }
}

export default {
  name: 'App',
  components: {
    SiteToolbar, Snackbars, FreshNews, SiteFooter,
    MobileBottomNav, ApiActivityIndicator, FlashArticle,
    Confirmation, CookieLaw,
    // Chat
  },
  data () {
    return {
      offsetTop: 0,
      whereIAm: null,
      newsarticles: [],
      lastArticle: readLastArticle(),
      flashArticle: null,
      newspage: 1,
    }
  },
  computed: {
    isInfinite () {
      return [
        'transfers', 'messages'
      ].includes(this.whereIAm)
    },
    isScrolled () {
      return this.offsetTop > 1000
    },
    profile () {
      return this.$store.state.profile
    },
    connected () {
      return this.$store.state.connected
    }
  },
  methods: {
    onScroll () {
      this.offsetTop = window.pageYOffset
    },
    async fetch () {
      this.newsarticles = await this.fetchNews()
      if (
        this.newsarticles[0] &&
        this.newsarticles[0].newsarticleid !== this.lastArticle &&
        moment().diff(moment(this.newsarticles[0].cts), 'days') < 30
      ) {
        this.flashArticle = this.newsarticles[0]
      }
    },
    async fetchNews () {
      const { newsarticles } = await this.$store.dispatch(
        'sioRequest', {
          topic: 'newsarticles-list',
          pl: {
            page: this.newspage,
            domain: 'deti.cdsvyatka.com'
          }
        }
      )
      return newsarticles.map(x => {
        x.date = moment(x.cts).format('DD.MM.YYYY')
        return x
      })
    },
    async addMoreNews () {
      this.newspage++
      const newsarticles = await this.fetchNews()
      this.newsarticles.push(...newsarticles)
    },
    closeFlash (article) {
      this.lastArticle = article.newsarticleid
      this.flashArticle = null
      localStorage.setItem('detiLastReadedArticle', article.newsarticleid)
    },
  },
  watch: {
    connected (val) {
      if (val) this.fetch()
    }
  },
  async mounted () {
    if (this.connected) await this.fetch()
  },
  created () {
    try {
      this.nightMode = JSON.parse(localStorage.getItem('detiNightMode') || 'false')
      console.log('nightmode is', this.nightMode ? 'on' : 'off')
    } catch (err) {
      console.log(err)
    }
    this.routeWatcher = this.$watch(
      function () { return this.$route },
      function (route) {
        if (route) this.whereIAm = route.name
      }
    )
  },
}
</script>

<style media="screen">
@import url("https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900");
@import url("https://fonts.googleapis.com/css?family=Roboto+Mono:100,300,400,500,700,900");
@font-face {
  font-family: 'Roboto';
  font-display: auto;
  src: local('Roboto');
}
@font-face {
  font-family: 'Roboto Mono';
  font-display: auto;
  src: local('Roboto Mono');
}
@font-face {
  font-family: 'Material Icons';
  font-display: auto;
  src: local('Material Icons');
}
h1, h2 {
  font-weight: 400;
}
h3, h4 {
  font-weight: 400;
}
body {
  min-width: 300px;
  width: auto !important;
  font-size: 16px;
  font-weight: 300;
}
@media (max-width: 400px) {
  #app-container {
    -padding-left: 8px;
    -padding-right: 8px;
  }
  .v-toolbar__content {
    padding-left: 10px;
    padding-right: 0;
  }
}
@media screen and (min-width : 320px) {
}
.application.theme--light {
  background-color: #F7F9FA;
}
li {
  list-style-type: none; /* Убираем маркеры */
}
ul {
  margin-left: 0; /* Отступ слева в браузере IE и Opera */
  padding-left: 0; /* Отступ слева в браузере Firefox, Safari, Chrome */
}
</style>
